// userApi.js
// User management service module for account operations
// Provides functions to retrieve, update, and delete user accounts
// Most operations require authentication, admin operations require admin role
// Used by account pages, user profile management, and admin user management

import apiRequest from "./api";

// Fetches a single user by ID
// Requires authentication token
// Returns user object with profile information
export const getUser = (id, token) =>
  apiRequest(`/User/${id}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` }
  });

// Fetches all users (admin only)
// Returns array of all user accounts in the system
export const getAllUsers = (token) =>
  apiRequest('/User', {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` }
  });

// Creates a new admin user account (admin only)
// Parameters: user object with account details, admin auth token
// Returns created user object
export const addUser = (user, token) =>
  apiRequest('/User', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}` 
    },
    body: JSON.stringify(user)
  });

// Updates user account information
// Uses PATCH method for partial updates (only changed fields)
// Parameters: user ID, updates object
// Returns updated user object
// Firebase token is automatically added by apiRequest function
export const updateUser = (id, updates) =>
  apiRequest(`/User/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });

// Deletes a user account
// Users can delete their own account, admins can delete any account
// Firebase token is automatically added by apiRequest function
export const deleteUser = (id) =>
  apiRequest(`/User/${id}`, {
    method: 'DELETE'
  });

